import { useEffect, useState } from "react";
import { TssApi } from "@jti/rest-api";
import { useUser } from "../../hooks/useUser";
export const useTrialStatus = ({ isTrial = true, categoryIds = [] }) => {
    const [eligibleCategoryIds, setEligibleCategoryIds] = useState(null);
    const { isLoggedIn, uuid } = useUser();
    useEffect(() => {
        if (!isTrial || categoryIds.length === 0) {
            setEligibleCategoryIds([]);
            return;
        }
        // Trial should be available for anonymous users
        if (isLoggedIn === false || uuid === null) {
            setEligibleCategoryIds(categoryIds);
            return;
        }
        const tssApi = TssApi.init();
        const eligibleCatgoriesPromises = categoryIds.map(async (categoryId) => {
            const isEligible = await tssApi.getEligibility({ categoryId, userId: uuid });
            return isEligible ? categoryId : null;
        });
        Promise.all(eligibleCatgoriesPromises).then((ids) => {
            const eligibleCategoryIds = ids.filter((id) => id !== null);
            setEligibleCategoryIds(eligibleCategoryIds);
        });
    }, [isTrial, isLoggedIn, uuid, categoryIds]);
    const isLoading = eligibleCategoryIds === null;
    const isTrialAvailable = !isLoading && eligibleCategoryIds.length > 0;
    return {
        eligibleCategoryIds: eligibleCategoryIds ?? [],
        isLoading,
        isTrialAvailable,
    };
};
//# sourceMappingURL=useTrialStatus.js.map